/* eslint-disable */

/*
* GENERAL
 */
$(window).resize(function(e){
  if (window.innerWidth > 992) {
    catHeight()
  }
});

if (window.innerWidth > 992) {
  catHeight()
}

/*
* AJAX CALLS
 */
reservasPage('.reservas-link a, .btn-reservas a', 'reservas', 'Reservas')
reservasPage('.almuerzo-link a', 'almuerzos', 'Almuerzos')
reservasPage('.regala-link a', 'regala', 'Regala')
reservasPage('.section-slider-buttons .ver-reservas', 'reservas', 'Reservas')
cartaPage( '.submenu-carta .item-submenu a' )
cartaPage( '.carta-link a' )
cartaPage( '.grupos-link a', false, true )
cartaPage( '.section-slider-buttons .ver-carta' )

changeLang()

accordion()
intCrossAnimation()
runAnimations()
slickCarousel()
cursorSliderProjectInit()
// animationStar()

$(window).scroll(function() {
  var scrollTop = $(this).scrollTop();
  $('.reservas-float-button .img-text').css('transform', 'rotate(' + scrollTop + 'deg)');
});


/*
* FUNCTIONS
 */
function cursorSliderProjectInit() {
  var projectImgContainer = $('.slider-platos .platos');

  $(document).mousemove(function(e) {
    $(".custom-cursor").css({
      left: e.pageX,
      top: e.pageY
    });
  });

  projectImgContainer.on('mouseover', function (){
    $(".custom-cursor").addClass('showCursor')
  })

  projectImgContainer.on('mouseleave', function (){
    $(".custom-cursor").removeClass('showCursor')
  })
}

function animationStar() {
  var sectionText = $('#section-intro .text .comboi'),
    star = $('#section-intro .estrella-almuerzo');

  let constrain = 20;
  let mouseOverContainer = document.getElementById("comboi");
  let ex1Layer = document.getElementById("estrella-almuerzo");

  function transforms(x, y, el) {
    let box = el.getBoundingClientRect();
    let calcX = -(y - box.y - (box.height / 2)) / constrain;
    let calcY = (x - box.x - (box.width / 2)) / constrain;

    return "perspective(100px) "
      + "   rotateX("+ calcX +"deg) "
      + "   rotateY("+ calcY +"deg) ";
  };

  function transformElement(el, xyEl) {
    el.style.transform  = transforms.apply(null, xyEl);
  }

  mouseOverContainer.onmousemove = function(e) {
    let xy = [e.clientX, e.clientY];
    let position = xy.concat([ex1Layer]);

    window.requestAnimationFrame(function(){
      transformElement(ex1Layer, position);
    });
  };

  // $(document).mousemove(function(e) {
  //   $(".custom-cursor").css({
  //     left: e.pageX,
  //     top: e.pageY
  //   });
  // });
  //
  // sectionText.on('mouseover', function (e){
  //   star.css({
  //     "left": (e.pageX * 0.02) + "%",
  //     "bottom": (e.pageY * 0.02) + "%"
  //   });
  //   // transform: translate3d(-100.5px, 5.3px, 0px);
  // })
  //
  // sectionText.on('mouseleave', function (e){
  //   star.css({
  //     "left": "35%",
  //     "bottom": "11%"
  //   });
  // })
}

function slickCarousel() {
  if ( $('#section-slider').length > 0 ) {
    $('.slider-platos .platos').slick({
      dots: false,
      infinite: true,
      autoplay: false,
      arrows: false,
      speed: 800,
      autoplaySpeed: 5000,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: false,
          }
        },
        {
          breakpoint: 993,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: false,
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: false,
          }
        },
      ]
    });
  }
  else {
    $('.slider-platos .platos').slick({
      dots: false,
      infinite: true,
      autoplay: false,
      arrows: false,
      speed: 800,
      autoplaySpeed: 5000,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: false,
          }
        },
        {
          breakpoint: 993,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: false,
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: false,
          }
        },
      ]
    });
  }
}

function catHeight() {
  if ($('.carta-single').length > 0) {
    var cat1 = $('.carta-single .cat-0').height(),
      cat2 = $('.carta-single .cat-1').height(),
      cat3 = $('.carta-single .cat-2').height(),
      cat4 = $('.carta-single .cat-3').height(),
      cat5 = $('.carta-single .cat-4').height(),
      cat6 = $('.carta-single .cat-5').height();

    $('.carta-single .cat-0').css({"border-bottom": "none", "border-right": "1.5px solid #30483D"});
    $('.carta-single .cat-0').parent().css({"border-bottom": "1.5px solid #30483D"});
    $('.carta-single .cat-2').css({"border-bottom": "none", "border-right": "1.5px solid #30483D"});
    $('.carta-single .cat-4').css({"border-bottom": "none", "border-right": "1.5px solid #30483D"});
  }
}

function accordion() {
  $('.toggle').on('click', function(e) {
    e.preventDefault();
    var openCloseIcon = $(this).find('.open-close-icon');
    var id = openCloseIcon.attr('id');
    // crossAnimation($(this))

    var $this = $(this);

    if ($('.' + $(this).data('section')).hasClass('show')) {
      $('.' + $(this).data('section')).removeClass('show');
      $('.' + $(this).data('section')).slideUp(350);
      $this.addClass('no-show');

      document.querySelector('#' + id).setDirection(-1);
      document.querySelector('#' + id).play();

    } else {
      // $this.parent().parent().find('.categorias').removeClass('show');
      // $this.parent().parent().find('.categorias').slideUp(350);
      $('.' + $(this).data('section')).addClass('show');
      $('.' + $(this).data('section')).slideDown(350);
      $this.removeClass('no-show');

      document.querySelector('#' + id).setDirection(1);
      document.querySelector('#' + id).play();
    }
  });
}

function crossAnimation(toggle) {
  var openCloseIcon = $(toggle).find('.open-close-icon');

  openCloseIcon.on('click', function (){
    var id = $(this).attr('id');
    if ($(this).hasClass('open')) {
      document.querySelector('#' + id).setDirection(-1);
      document.querySelector('#' + id).play();
      $(this).removeClass('open')
    }
    else {
      document.querySelector('#' + id).setDirection(1);
      document.querySelector('#' + id).play();
      $(this).addClass('open')
    }

  })
}

function intCrossAnimation() {
  if ($('.open-close-icon').length > 0) {
    $('.open-close-icon').each(function (){
      var id = $(this).attr('id');

      if ($(this).hasClass('open')) {
        document.querySelector('#' + id).setDirection(1);
        document.querySelector('#' + id).play();
        $(this).addClass('open')
      }
    });
  }
}

function runAnimations() {
  initTriggers()
  headerAnimations()
  footerAnimations()
  preLoaderAnimations()
  frontPageAnimations()
  showTitles()

  setTimeout(function (){
    showFirstTitles()
  }, 2800)
}

function preLoaderAnimations() {
  const player = document.querySelector("#pre-loader");
  $('body').css({ "padding-top": $('header').height() + "px", })
  player.addEventListener("complete", (e) => {
    $('.barmistela-pre-loader').addClass('hide-preloader');
    $('header').addClass('show-header');

    setTimeout(function (){
      introFrontPageAnimations();
      if ($('.frontpage-page').length === 0) {
        //showFirstTitles()
      }
      // Init show popup trigger
      if(jQuery('.home').length > 0){
        $(document).trigger('showPopupHome');
      }
    }, 1000)

    setTimeout(function (){
      $('body').trigger('show-menu-2');
    }, 600)
  });
}

setTimeout(function (){
  // Init show popup trigger
  if(jQuery('.home').length > 0){
    $(document).trigger('showPopupHome');
  }

  if(jQuery('.single-carta').length > 0){
    $(document).trigger('showPopupCarta');
  }
}, 1000)

function introFrontPageAnimations() {
  $('header').addClass('sticky');
  $('body')
    .css({ "padding-top": "0px" })
    .trigger('preloader-show-bottom-top');

  if (window.innerWidth > 992) {
    // $(document)
    //   .trigger('content-title', [$('#intro-title')]);
  }
}

function headerAnimations() {
  $('.menu-item a, .gastro-link a, .regala-link a,.contacto-link a, .reservas-link a, .item-submenu a, #section-reserva a, .link-animation a').on('mouseenter', function (){
    $('body').trigger('link-animation', [$(this).attr('id')]);
  })

  $('body').on('link-animation', function (event, itemId){
    if (window.innerWidth > 992) {
      var element = $('#' + itemId),
        last    = element.find('.item-loop-last'),
        first   = element.find('.item-loop-first'),
        clone   = last.clone();

      if (! element.hasClass('looping')) {
        element.addClass('looping');

        var sum = 20;
        if (itemId === 'menu-item-reservas') {
          sum = 40;
        }

        first.animate({
          bottom: "+=" + sum,
        }, 500, "linear", function() {
          // first.hide().css({"bottom":"-50px"})
          first.remove();
          clone.appendTo('#' + itemId);
          element.removeClass('looping');
        });

        last.animate({
          bottom: "+=" + sum,
        }, 500, "linear", function() {
          last.removeClass('item-loop-last').addClass('item-loop-first')
        });
      }

    }
  } )
}

function footerAnimations() {
  const footer = document.getElementById("footer");
  $(window).scroll(function(){
    if ($(window).scrollTop()  >= footer.offsetTop - 1000 ) {
      $(document)
        .trigger('bg-show-bottom-top', [$('#footer')]);
    }
  });
}

function frontPageAnimations() {
  if ($('.frontpage-page').length > 0) {
    const sectionHomeSlider = document.getElementById("almuerzos-slider");
    const sectionHorario = document.getElementById("section-horario");

    if (window.innerWidth <= 992) {
      $(window).scroll(function(){
        if ($(window).scrollTop()  >= sectionHomeSlider.offsetTop - 600 ) {
          $('#section-intro').addClass('active');
        }

        if ($(window).scrollTop()  >= sectionHorario.offsetTop - 300 ) {
          $(document)
            .trigger('bg-show-bottom-top-mobile', [$('#section-horario')]);
          // .trigger('content-title', [$('#horario')]);
          $('#almuerzos-slider').addClass('active');
          $('#section-columnas').addClass('active');
        }

      });
    }
    else {
      $(window).scroll(function(){
        if ($(window).scrollTop()  >= sectionHomeSlider.offsetTop - 800 ) {
          $('#section-intro').addClass('active');
        }

        if ($(window).scrollTop()  >= sectionHorario.offsetTop - 600 ) {
          $(document)
            .trigger('bg-show-bottom-top', [$('#section-horario')]);
          $('#almuerzos-slider').addClass('active');
          $('#section-columnas').addClass('active');
        }
      });
    }
  }

  if ($('.almuerzos-page').length > 0) {
    const sectionHomeSlider = document.getElementById("section-slider");
    const sectionReserva = document.getElementById("alumuerzos-reserva");

    if (window.innerWidth <= 992) {
      $(window).scroll(function(){
        if ($(window).scrollTop()  >= sectionReserva.offsetTop - 300 ) {
          $('#section-slider').addClass('active');
        }

      });
    }
    else {
      $(window).scroll(function(){
        if ($(window).scrollTop()  >= sectionReserva.offsetTop - 600 ) {
          $('#section-slider').addClass('active');
        }
      });
    }
  }
}

function showTitles() {
  var sections = $('section');

  if (sections.length > 0) {
    sections.each(function (index, element){
      var title = $(element).find('.content-title');

      $(window).scroll(function(){
        if ($(window).scrollTop()  >= element.offsetTop - 300) {
          $(document)
            .trigger('content-title', [title]);
        }
      })

    })
  }
}

function showFirstTitles() {
  var contentTitle = $('.content-title').first(),
    contentTitleFirst = $('.content-title.first');

  if ( contentTitle.attr('id') !== 'intro-title' ) {
    $(document)
      .trigger('content-title', [contentTitle]);
    $(document)
      .trigger('content-title', [contentTitleFirst]);
  }
}

function initTriggers() {
  $(document)
    .on('show-menu-2', function (){
      $('.menu-container').addClass('show-menu-2');
    })
    .on('preloader-show-bottom-top', function (){
      $('.preloader-show-bottom-top').addClass('active');
    })
    .on('show-bottom-top', function (){
      $('.show-bottom-top').addClass('active');
    })
    .on('bg-show-bottom-top', function (event, element){
      if ($(element).attr('id') === 'footer') {
        $(element).addClass('active');
      }
      else {
        $(element).find('.bg-show-bottom-top').addClass('active');
      }
    })
    .on('bg-show-bottom-top-mobile', function (event, element){
      $(element).find('.bg-show-bottom-top-mobile').addClass('active');
    })
    .on('content-title', function (event, title){
      $(title).find('h1').addClass('active');
      $(title).find('h2').addClass('active');
    })
}


/*
* AJAX CALLS
 */
function reservasPage(elements, slug, textPage, reload) {
  $(elements).on('click', function (event) {
    event.preventDefault();
    showLoaderPage(textPage);

    var url = $(this).attr('href');

    $.ajax({
      type: 'POST',
      url: '/wp-admin/admin-ajax.php',
      dataType: 'json',
      data: {
        action: 'barmistela_get_general_page',
        slug: slug,
      },
      beforeSend: function() {
        setTimeout(function (){
          $('header .submenu-carta').remove();
        }, 1000);
      },
      success(res) {
        $("html, body").animate({scrollTop: 0}, 200);
        setTimeout(function (){
          $('.menu-container .lang-menu').addClass('d-none');
          $('#main-nav').addClass('w-100');
          $('.page__content').html(res.data.html);
          hideLoaderPage()

          if(!$('body').hasClass('cartaLoad')){
            cartaPage( '.submenu-carta .item-submenu a' )
            //cartaPage( '.carta-link a' )
            cartaPage( '.section-slider-buttons .ver-carta' )
          }

          reloadScrips(slug, reload)
        }, 500);

        window.history.pushState({ path: url }, '', url);
      },
    });
  });
}

function cartaPage(element, reload, isGrupos) {
  $(element).on('click', function (event) {
    // $('body').addClass('loadingPage');

    event.preventDefault();
    var id    = $(this).attr('id'),
      url   = $(this).attr('href'),
      lang  = null,
      title = $(this).data('title');

    if(id === 'esmorzar') {
      showLoaderPage(title);
    }
    else if(id === 'dinar-sopar') {
      showLoaderPage(title);
    }
    else if(id === 'postres-y-digestivos') {
      showLoaderPage(title);
    }
    else if(id === 'tapas-entre-horas') {
      showLoaderPage(title);
    }
    else if(id === 'vinos') {
      showLoaderPage(title);
    }
    else if(id === 'grupos' || isGrupos) {
      showLoaderPage('Menú Grupos');
    }
    else {
      showLoaderPage('Carta');
    }

    if ( getUrlParameter('lang') ) {
      lang = urlParam('lang');
    }

    $.ajax({
      type: 'POST',
      url: '/wp-admin/admin-ajax.php',
      dataType: 'json',
      data: {
        action: 'barmistela_get_carta_page',
        slug: isGrupos ? 'grupos' : $(this).attr('id'),
        lang: lang,
      },
      beforeSend: function() {

      },
      success(res) {

        $("html, body").animate({scrollTop: 0}, 200);
        setTimeout(function (){
          $('.menu-container .lang-menu').removeClass('d-none');
          $('#main-nav').removeClass('w-100');
          $(document).trigger('showPopupCarta');

          if ( lang ) {
            window.history.pushState({ path: url + '?lang=' + lang }, '', url + '?lang=' + lang);
          }
          else {
            window.history.pushState({ path: url }, '', url);
          }

          $('.page__content').html(res.data.html);
          $('header .submenu-carta').remove();
          $('header').append(res.data.submenu)

          cartaPage( '.submenu-carta .item-submenu a' )
          //cartaPage( '.carta-link a' )
          // cartaPage( '.caca-link a' )
          cartaPage( '.section-slider-buttons .ver-carta' )

          accordion()
          intCrossAnimation()

          reloadScrips(false, reload)
          hideLoaderPage()
        }, 500);
      },
    });
  });
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

function urlParam(name) {
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results==null) {
    return null;
  }
  return decodeURI(results[1]) || 0;
}

function showLoaderPage(text) {
  $('.barmistela-loader-page .text').html(text);
  $('.barmistela-loader-page').addClass('active');

  console.log('showLoaderPage');

  $("body").trigger("showP5");
}

function hideLoaderPage() {
  setTimeout(function (){
    $('.barmistela-loader-page').removeClass('active');
    $("body").trigger("hideP5");
    $('body').removeClass('loadingPage');
    //$('#animation canvas').remove();
  }, 2000);
}

function reloadScrips(slug, reload) {
  $(window).resize(function(e){
    if (window.innerWidth > 992) {
      catHeight()
    }
  });

  if (window.innerWidth > 992) {
    catHeight()
  }

  setTimeout(function (){
    introFrontPageAnimations()
    initTriggers()
    headerAnimations()
    footerAnimations()
    frontPageAnimations()

    showTitles()

    changeLang()
    slickCarousel()
    cursorSliderProjectInit()
  }, 2000);

  setTimeout(function (){
    showFirstTitles()
  }, 2800)
}

function changeLang() {
  $('.lang-menu a').on('click', function (){
    var url = window.location.href;

    const urlObj = new URL(url);
    urlObj.search = '';
    url = urlObj.toString();

    if ( $(this).data('lang') === 'en' ) {
      window.location.replace(url + '?lang=' + $(this).data('lang'));
    }
    else {
      window.location.replace(url);
    }

  });
}
